<template>
  <div :class="classes">
     <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber"
      :page-size="pageSize" :current-page="currentPage" ref="table"  isAddPageToRouter :isOutside="isOutside">
          <wt-table :list="tableData" :labels="tableLabels">
            <template>
              <slot/>
            </template>
          </wt-table>
      </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-pt-feedback-table'

export default {
  name: 'pt-pt-feedback-table',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.table.page
    }
  },
  props: {
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 0
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    isOutside: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isSelect: true,
      id: []
    }
  },
  methods: {
    toSelect (selection, val) {
      // 选中或者取消选中单条数据
      if (this.id.indexOf(val.id) === -1) {
        // 不存在,则添加
        this.id.push(val.id)
      } else {
        // 存在,则删除
        this.id.splice(this.id.indexOf(val.id), 1)
      }
    },
    selectAll (selection) {
      for (let i = 0; i < selection.length; i++) {
        this.id.push(selection[i].id)
      }
    },
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next) {
      this.$emit('getFeedbackList', page, next)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
